// focus-selector.js

import { createSelector } from "reselect";

import {
  getParsedQuery,
  removeQueryParams,
  updateLocation,
} from "../helpers/router";

export const INITIAL_STATE = {
  isDragging: false,
  start: null,
  end: null,
  minResponseTime: "",
};

// action types
const START_DRAGGING = "trace-web/focus-selector/START_DRAGGING";
const UPDATE_DRAGGING = "trace-web/focus-selector/UPDATE_DRAGGING";
const END_DRAGGING = "trace-web/focus-selector/END_DRAGGING";
const CLOSE_SELECTOR = "trace-web/focus-selector/CLOSE_SELECTOR";
const UPDATE_MIN_RESPONSE_TIME =
  "trace-web/focus-selector/UPDATE_MIN_RESPONSE_TIME";

// reducer
const focusSelectorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case START_DRAGGING:
      return {
        ...state,
        isDragging: true,
        start: action.coordinates,
        end: null,
        minResponseTime: "",
      };
    case UPDATE_DRAGGING:
      return {
        ...state,
        isDragging: true,
        end: action.coordinates,
        minResponseTime: "",
      };
    case END_DRAGGING:
      return {
        ...state,
        isDragging: false,
        end: action.coordinates,
        minResponseTime: "",
      };
    case CLOSE_SELECTOR: // behavior here should support minResponseTime remaining
      return {
        ...INITIAL_STATE,
      };
    case UPDATE_MIN_RESPONSE_TIME:
      return {
        ...INITIAL_STATE,
        minResponseTime: action.minResponseTime,
      };
    default:
      return state;
  }
};
export default focusSelectorReducer;

// action creators
export const startDragging = coordinates => {
  return {
    type: START_DRAGGING,
    coordinates,
  };
};

export const updateDragging = coordinates => {
  return {
    type: UPDATE_DRAGGING,
    coordinates,
  };
};

export const endDragging = coordinates => {
  return {
    type: END_DRAGGING,
    coordinates,
  };
};

export const closeSelector = () => {
  return {
    type: CLOSE_SELECTOR,
  };
};

export const updateMinResponseTime = minResponseTime => {
  return {
    type: UPDATE_MIN_RESPONSE_TIME,
    minResponseTime,
  };
};

// functions
export const goToFocus = (router, location, focus) => {
  const loc = updateLocation(location, undefined, {
    focus_start: focus.start,
    focus_end: focus.end,
    focus_min: focus.min,
    focus_max: focus.max,
  });
  router.replace(loc);
};

/**
 * @param {number} focusMin - The minimum focus in milliseconds.
 */
export const goToFocusMin = (router, location, focusMin) => {
  let loc = removeQueryParams(location, [
    "focus_start",
    "focus_end",
    "focus_min",
    "focus_max",
  ]);

  if (focusMin) {
    loc = updateLocation(loc, undefined, {
      focus_min: focusMin * 1000, // milliseconds to microseconds
    });
  }

  router.replace(loc);
};

export const clearFocus = (router, location) => {
  const loc = removeQueryParams(location, [
    "focus_start",
    "focus_end",
    "focus_min",
    "focus_max",
  ]);
  router.replace(loc);
};

// selectors
export const getFocus = createSelector(
  [getParsedQuery],
  ({ focus_start, focus_end, focus_min, focus_max }) => {
    return {
      start: focus_start ? Number(focus_start) * 1000 : undefined,
      end: focus_end ? Number(focus_end) * 1000 : undefined,
      min: focus_min,
      max: focus_max,
    };
  }
);

export const getResponseTimeFilter = state =>
  state.ui.focusSelector.minResponseTime;
